<div
    class="modal fade show in"
    [ngClass]="{'expanded': isExpanded}"
    id="checklist-modal"
    tabindex="-1"
    aria-labelledby="checklist-modalLabel"
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
<app-loader *ngIf="showLoader"></app-loader>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <app-popup-header
                [isExpanded]="isExpanded"
                [title]="'Checklist'"
                (onClose)="close()"
                (onExpandCollapse)="expandCollapse($event)"
            ></app-popup-header>
            <div class="modal-body py-2">
                <p>Serialized Item Group - {{serializedItemGroupDescription}}</p>
                <div class="content mb-1">
                    <div class="size">
                        <ejs-dropdownlist
                            id='checklist-ddl'
                            [dataSource]='dropDownValues'
                            placeholder = 'Please select checklist'
                            (change)='onChecklistChange($event)'
                            [(value)]="selectedItem"
                            [enabled]="true"
                        ></ejs-dropdownlist>
                    </div>
                    <div class="right">
                        <button class="border color1" (click)="acceptAllClick($event)" ejs-button cssClass="e-link">Approve All</button>
                        <button class="border color2" (click)="rejectAllClick($event)" ejs-button cssClass="e-link">Reject All</button>
                    </div>
                </div>
                <!-- The old grid's 470px (#checklist-popup-grid), no paging: the rows scroll. -->
                <div class="checklist-popup-grid" [id]="checklistPopupGridId">
                    @if (checklistConfig) {
                    <inavista-grid #checklistPopupGrid class="so-popup-grid"
                        [config]="checklistConfig"
                        [actionIcons]="checklistActionIcons"
                        (rowCommit)="onChecklistCommit($event)"
                        (actionIconClick)="onChecklistActionIconClick($event)"
                        (exportRequested)="onChecklistExportRequested()" />
                    }
                </div>
            </div>
            <div class="modal-footer p-0">
                <button class="btn btn-sm btn-danger me-2 comment-action-item" (click)="close()">Close</button>
                <button class="btn btn-sm btn-success me-2 comment-action-item" (click)="saveChecklist(false, true)" [disabled]="disabledStatus">Save and Close</button>
                <button class="btn btn-sm btn-success comment-action-item" (click)="generate()" [disabled]="disabledStatus">Save & Generate</button>
            </div>
        </div>
    </div>
</div>


<!-- Status: the old coloured pill. -->
<ng-template #statusCell let-row>
    <span class="grid-status-column {{row?.isOverdue ? 'overdue' : getStatusClass(row?.status)}}">
        <i class="fas fa-info me-1" *ngIf="row?.isOverdue"></i>
        {{row?.status}}
    </span>
</ng-template>

<app-invoice-popup *ngIf="showInvoicePopup"
    [popupOpenedFrom]="InvoicePopupOpened.checklist"
    [serviceOrderData]="serviceOrderData"
    [checklistId]="hasChecklist"
    [checklistType]="selectedItem"
    [heading]="heading"
    [Object]="object"
    [checklistCertificate]="checklistCertificate"
    [invoice]="invoice"
    [isDraft]="false"
    [fieldRules]="fieldRules"
    [customerData]="customerData"
    [isSigned]="isSigned"
    (onSigned)="onInvoiceSigned($event)"
    (onClose)="onInvoicePopupClosed($event)"
    (certificateGenerate)="certificateGenerate.emit()"
></app-invoice-popup>
